import useGenericEntityStore from '@/layouts/entity/entityStoreModule'

const { storeModule } = useGenericEntityStore('poll-categories')
export default storeModule
